/**
 * @file サポーター登録
 */
'use strict'

/**
 * @classname CheckSupporterRegistration
 * @classdesc サポーター登録
 */
export default class CheckSupporterRegistration {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.supporter-registration')
	 * @param {instance} controller
	 */
	constructor($e, controller) {
		console.log('CheckSupporterRegistration.constructor')
		this._$e = $e;
		let create = true;
		if($e.closest('.list-item-additional')[0]){
			create = false;
		}
		this._$e.on('click', () => {
			if(create){
				this.create();
			}else{
				this.show();
			}
		});
		if(create){
			this.create();
		}else{
			this.show();
		}
	}

	/**
	 * クリックのコールバック（新規作成）
	 *
	 * @memberof CheckSupporterRegistration
	 * @return {undefined}
	 */
	create() {
		console.log('CheckSupporterRegistration.create');
		if(this._$e.prop('checked')){
			console.log('checked');
			const val = $('.supporter-registration:checked').val();
			if(val === '1'){
				$('.scout_member_ids').removeClass('ignore-validate');
				$('.master_den_ids')
					.addClass('ignore-validate')
					.removeClass('is-invalid')
					.closest('.form-group')
					.find('.error-tip')
					.removeClass('show')
					.find('.error-tip-inner')
					.html('');
			}else if(val === '2'){
				$('.scout_member_ids')
					.addClass('ignore-validate')
					.removeClass('is-invalid')
					.closest('.form-group')
					.find('.error-tip')
					.removeClass('show')
					.find('.error-tip-inner')
					.html('');
				$('.master_den_ids').removeClass('ignore-validate');
			}
		}else{
			$('.scout_member_ids').addClass('ignore-validate').removeClass('is-invalid');
			$('.master_den_ids').addClass('ignore-validate').removeClass('is-invalid');
			$('.error-tip').removeClass('show').find('.error-tip-inner').html('');
		}
	}


	/**
	 * クリックのコールバック（詳細）
	 *
	 * @memberof CheckSupporterRegistration
	 * @return {undefined}
	 */
	show() {
		console.log('CheckSupporterRegistration.show');
		if(this._$e.prop('checked')){
			console.log('checked');
			$('.list-item-additional').each((idx, e) => {
				const $e = $(e);
				const val = $e.find('.supporter-registration:checked').val();
				if(val === '1'){
					$e.find('.scout_member_ids').removeClass('ignore-validate');
					$e.find('.master_den_ids')
						.addClass('ignore-validate')
						.removeClass('is-invalid')
						.closest('.form-group')
						.find('.error-tip')
						.removeClass('show')
						.find('.error-tip-inner')
						.html('');
				}else if(val === '2'){
					$e.find('.scout_member_ids')
						.addClass('ignore-validate')
						.removeClass('is-invalid')
						.closest('.form-group')
						.find('.error-tip')
						.removeClass('show')
						.find('.error-tip-inner')
						.html('');
					$e.find('.master_den_ids').removeClass('ignore-validate');
				}
			})
		}else{
			$('.list-item-additional .scout_member_ids').addClass('ignore-validate').removeClass('is-invalid');
			$('.list-item-additional .master_den_ids').addClass('ignore-validate').removeClass('is-invalid');
		}
	}
}
